module.exports = "/_next/static/images/3db3aee199e7c24203d10f13948342bd-image-left-lg.jpg";